import React from 'react';
import './RugbyFieldSVG.css';

/**
 * SVG Rugby Field Component with theme support via CSS
 * Styling is controlled through CSS variables in RugbyFieldSVG.css
 */
const RugbyFieldSVG = ({ children, width = "100%", height = "100%", teamDirection = 'left-to-right' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 120 70"
      version="1.1"
      preserveAspectRatio="xMidYMid meet"
      className="rugby-field-svg"
    >
      {/* Defs - Patterns for the field */}
      <defs>
        <pattern
          id="stripes-grid"
          patternUnits="userSpaceOnUse"
          width="3"
          height="10"
          patternTransform="scale(2)"
          className="rugby-field-stripes"
        >
          <rect
            className="rugby-field-stripes-rect"
            x="0"
            y="0"
            width="2"
            height="10"
          />
        </pattern>
        <pattern
          id="pattern14"
          href="#stripes-grid"
          patternTransform="matrix(0,2.5,-2.5,0,0,0)"
          x="2.7"
          y="0"
          width="4.2"
        />
      </defs>
      
      {/* Pitch Layer - Main field background */}
      <g>
        <rect
          className="rugby-field-grass"
          width="120"
          height="70"
          x="0"
          y="0"
        />
        
        {/* Add stripes pattern overlay for texture */}
        <rect
          style={{ fill: 'url(#pattern14)', fillOpacity: 0.3 }}
          width="120"
          height="70"
          x="0"
          y="0"
        />
      </g>
      
      {/* Lines Layer */}
      <g>
        {/* Try line right */}
        <path 
          className="rugby-field-line"
          style={{ strokeWidth: 0.809 }}
          d="M 110.4095,0 V 70" 
        />
        
        {/* 22m right */}
        <path 
          className="rugby-field-line"
          style={{ strokeWidth: 0.814202 }}
          d="M 88.407101,0 V 70" 
        />
        
        {/* 5m right markings */}
        <g transform="matrix(-1,0,0,1,121,2.055e-4)">
          <g>
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="m 15.335351,2.4917945 v 6"
            />
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="M 21,5.4917945 H 15"
            />
          </g>
          <g transform="translate(0,10.000206)">
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="m 15.335351,2.4917945 v 6"
            />
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="M 21,5.4917945 H 15"
            />
          </g>
          <g transform="translate(0,49.875205)">
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="m 15.335351,2.4917945 v 6"
            />
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="M 21,5.4917945 H 15"
            />
          </g>
          <g transform="translate(0,57.24968)">
            <g>
              <path
                className="rugby-field-marking"
                style={{ strokeWidth: 0.734718 }}
                d="m 15.335351,5.117679 v 6"
              />
              <path
                className="rugby-field-marking"
                style={{ strokeWidth: 0.734718 }}
                d="M 21,8.117679 H 15"
              />
            </g>
          </g>
          <g transform="matrix(-1,0,0,1,97.302083,6.3137228)">
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="m 81.966732,25.545853 v 6"
            />
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="m 81.966732,15.566593 v 6"
            />
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="m 81.966732,35.525114 v 6"
            />
          </g>
        </g>
        
        {/* 10m right markings */}
        <g>
          <path
            className="rugby-field-marking"
            style={{ strokeWidth: 0.734718 }}
            d="m 70.367359,1.922 v 6"
          />
          <path
            className="rugby-field-marking"
            style={{ strokeWidth: 0.734718 }}
            d="m 70.367359,11.922206 v 6.000001"
          />
          <path
            className="rugby-field-marking"
            style={{ strokeWidth: 0.734718 }}
            d="m 70.367359,31.859781 v 6"
          />
          <path
            className="rugby-field-marking"
            style={{ strokeWidth: 0.734718 }}
            d="m 70.367359,21.880521 v 6"
          />
          <path
            className="rugby-field-marking"
            style={{ strokeWidth: 0.734718 }}
            d="m 70.367359,41.839042 v 6"
          />
          <path
            className="rugby-field-marking"
            style={{ strokeWidth: 0.734718 }}
            d="m 70.367359,51.797205 v 6"
          />
          <path
            className="rugby-field-marking"
            style={{ strokeWidth: 0.734718 }}
            d="m 70.367359,61.797563 v 6.000001"
          />
        </g>
        
        {/* Half way line */}
        <path 
          className="rugby-field-line"
          style={{ strokeWidth: 0.814202 }}
          d="M 60.4045,0 V 70" 
        />
        
        {/* 10m left markings */}
        <g transform="translate(3.6979169,7.8997305)">
          <path
            className="rugby-field-marking"
            style={{ strokeWidth: 0.734718 }}
            d="m 46.669442,-5.9777304 v 6"
          />
          <path
            className="rugby-field-marking"
            style={{ strokeWidth: 0.734718 }}
            d="M 46.669442,4.0224756 V 10.022477"
          />
          <path
            className="rugby-field-marking"
            style={{ strokeWidth: 0.734718 }}
            d="m 46.669442,23.960051 v 6"
          />
          <path
            className="rugby-field-marking"
            style={{ strokeWidth: 0.734718 }}
            d="m 46.669442,13.980791 v 6"
          />
          <path
            className="rugby-field-marking"
            style={{ strokeWidth: 0.734718 }}
            d="m 46.669442,33.939312 v 6"
          />
          <path
            className="rugby-field-marking"
            style={{ strokeWidth: 0.734718 }}
            d="m 46.669442,43.897475 v 6"
          />
          <path
            className="rugby-field-marking"
            style={{ strokeWidth: 0.734718 }}
            d="m 46.669442,53.897833 v 6.000001"
          />
        </g>
        
        {/* 22m left */}
        <path 
          className="rugby-field-line"
          style={{ strokeWidth: 0.814202 }}
          d="M 32.401899,0 V 70" 
        />
        
        {/* 5m left markings */}
        <g>
          <g>
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="m 15.335351,1.922321 v 6"
            />
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="M 21,4.922321 H 15"
            />
          </g>
          <g transform="translate(23.697917,6.5523114)">
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="m -8.330558,25.30747 v 6"
            />
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="m -8.330558,15.32821 v 6"
            />
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="m -8.330558,35.286731 v 6"
            />
          </g>
          <g>
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="m 15.335351,11.922528 v 5.999999"
            />
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="M 21,14.922528 H 15"
            />
          </g>
          <g>
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="m 15.335351,51.797525 v 6.000001"
            />
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="M 21,54.797525 H 15"
            />
          </g>
          <g>
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="m 15.335351,61.797885 v 6"
            />
            <path
              className="rugby-field-marking"
              style={{ strokeWidth: 0.734718 }}
              d="M 21,64.797885 H 15"
            />
          </g>
        </g>
        
        {/* Try line left */}
        <path 
          className="rugby-field-line"
          style={{ strokeWidth: 0.814202 }}
          d="M 10.4045,0 V 70" 
        />
        
        {/* Field outline */}
        <rect
          className="rugby-field-outline"
          style={{ strokeWidth: 0.809 }}
          width="120"
          height="70"
          x="0"
          y="0"
          ry="0"
        />
      </g>
      
      {/* Goals */}
      <g>
        {/* Goal right */}
        <g transform="matrix(0.64044949,0,0,0.89244314,60.376198,1.376641)">
          <path
            className="rugby-field-goal"
            style={{ strokeWidth: 0.509 }}
            d="m 81.47525,33.59018 v 8.15609"
          />
          <path
            className="rugby-field-goal"
            style={{ strokeWidth: 0.809001 }}
            d="m 77.482773,33.590177 h 9.551202"
          />
          <path
            className="rugby-field-goal"
            style={{ strokeWidth: 0.809001 }}
            d="m 77.482773,41.761094 h 9.551202"
          />
        </g>
        
        {/* Goal left */}
        <g transform="matrix(-0.64044949,0,0,-0.89244314,59.740865,68.623366)">
          <path
            className="rugby-field-goal"
            style={{ strokeWidth: 0.509 }}
            d="m 81.47525,33.59018 v 8.15609"
          />
          <path
            className="rugby-field-goal"
            style={{ strokeWidth: 0.809001 }}
            d="m 77.482773,33.590177 h 9.551202"
          />
          <path
            className="rugby-field-goal"
            style={{ strokeWidth: 0.809001 }}
            d="m 77.482773,41.761094 h 9.551202"
          />
        </g>
      </g>
      
      {/* Children - allows adding overlays, markers, etc. */}
      {children}
    </svg>
  );
};

export default RugbyFieldSVG;